import { makeEnvironmentProviders, Provider } from '@angular/core';
import { MATCH_CONTEXT, NO_MATCH_CONTEXT, PREDICTION_GAME_SERVICE } from '@kikkz/shared/prediction-game/util';
import { HttpPredictionGameService } from '../services/http-prediction-game.service';
import { FixturesStore } from '../store/fixtures.store';
import { RankingStore } from '../store/ranking.store';
import { GroupsStore } from '../store/groups.store';
import { HallOfFameStore } from '../store/hall-of-fame.store';
import { MatchdayWinnersStore } from '../store/matchday-winners.store';
import { PredictionGameFacade } from '../facade/prediction-game.facade';

export interface PredictionGameOptions {
  /**
   * Binds `PREDICTION_GAME_SERVICE` to something other than the real HTTP transport
   * (a mock or a tenant-specific implementation). Defaults to
   * {@link HttpPredictionGameService}, which serves both tenants.
   */
  service?: Provider;
  /**
   * Binds `MATCH_CONTEXT` — which fixture the host app wants shown first. Defaults to
   * {@link NO_MATCH_CONTEXT}, so a tenant whose host app never deep-links a match needs
   * no wiring at all.
   */
  matchContext?: Provider;
}

/**
 * Provides the tenant-neutral prediction game: the transport behind
 * `PREDICTION_GAME_SERVICE`, the region stores and the facade the feature layer
 * talks to.
 *
 * The apps layer additionally supplies `PREDICTION_GAME_TENANT_CONFIG` — together with
 * the optional `matchContext` these are the seams that make this core tenant-agnostic.
 */
export function providePredictionGame(options: PredictionGameOptions = {}) {
  return makeEnvironmentProviders([
    options.service ?? { provide: PREDICTION_GAME_SERVICE, useExisting: HttpPredictionGameService },
    options.matchContext ?? { provide: MATCH_CONTEXT, useValue: NO_MATCH_CONTEXT },
    FixturesStore,
    RankingStore,
    GroupsStore,
    HallOfFameStore,
    MatchdayWinnersStore,
    PredictionGameFacade,
  ]);
}
